export enum EReligion {
	islam = 'islam',
	christian = 'christian',
	chatolic = 'chatolic',
	hindu = 'hindu',
	buddha = 'buddha',
	confucianism = 'confucianism' // Kong Hu Cu
}

export enum EProfileMainEmail {
	PRIVATE = 'PRIVATE', // Private email
	REMAX = 'REMAX' // Remax email
}

export type ProfileProperties = {
	userId: string;
	martialStatus: 'married'|'single';
	religion?: EReligion;
	homePhone?: string;
	firstPhoneNumber: string;
	secondPhoneNumber?: string;
	privateEmail: string;
	remaxEmail?: string;
	mainEmail?: EProfileMainEmail;
	nik?: string;
	npwp?: string;
	createdAt?: Date;
	updatedAt?: Date;
}